// extracted by mini-css-extract-plugin
export default {"documentsContainer":"Documents_documentsContainer__2JWlS","cardsContainer":"Documents_cardsContainer__TOtCj"};